import React from "react";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { PiInfo } from "react-icons/pi";
import { FaCheck } from "react-icons/fa"; // Import FaCheck

const InfoStatusJawab = () => {
  // Konten tooltip yang lebih informatif dan terstruktur
  const tooltipDetailedContent = (
    <div className=" text-left rounded-lg"> {/* Div yang diminta, dengan padding */}
      <p className="font-semibold mb-2 text-sm p-2 backgroundColor text-center p-2">Keterangan Soal</p>
      <ul className="list-none text-xs space-y-2 p-2">
        <li className="flex items-center">
          <div className="relative">
            <span className="inline-flex items-center justify-center w-6 h-6 text-xs bg-[#2D7DBE] text-white rounded mr-2">
              1
            </span>
          </div>
          <span style={{marginBottom: "0.125rem"}}>Sudah Dikerjakan</span>
        </li>
        <li className="flex items-center">
          <span className="inline-flex items-center justify-center w-6 h-6 text-xs bg-[#F3F3F3] text-[#C9C9C9] border border-gray-300 rounded mr-2">
            2
          </span>
          <span style={{marginBottom: "0.125rem"}}>Belum Dikerjakan</span>
        </li>
        <li className="flex items-center">
          <span className="inline-flex items-center justify-center w-6 h-6 text-xs bg-[#01B224] text-white border border-blue-400 rounded mr-2">
            3
          </span>
          <span style={{marginBottom: "0.125rem"}}>Soal Sedang Dilihat</span>
        </li>
      </ul>
    </div>
  );

  return (
    <>
    <span
        data-tooltip-id="info-status-tooltip" // ID unik untuk tooltip
        data-tooltip-place="bottom-end" // Posisi tooltip
        >
        <PiInfo className="text-xl text-gray-500 hover:text-blue-600 cursor-pointer"/>
    </span>

    <ReactTooltip
        id="info-status-tooltip"
        className="border boder-muted rounded-lg custom-tooltip-style !opacity-100" // Menambahkan !opacity-100 jika ada masalah dengan opacity default
        style={{
          backgroundColor: '#ffffff', // Tailwind bg-gray-700
          color: '#000000', // Tailwind text-white
          padding: '0px', // Padding diatur oleh div di dalam
          borderRadius: '0.5rem', // Tailwind rounded-lg
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Tailwind shadow-lg
          zIndex: 9999, // Untuk memastikan tooltip muncul di atas
        }}
      >
        {tooltipDetailedContent}
      </ReactTooltip>
    </>
  );
};

export default InfoStatusJawab;